<span class="step-badge" contenteditable="false">{{ stepIndex() }}</span>

@if (isEditable()) {
  <div class="step-actions" contenteditable="false">
    <button type="button" class="step-action-btn" (click)="moveStepUp()" dojoStopPropagation title="Move up">
      <dojo-icon icon="chevron-up" [size]="12" />
    </button>
    <button type="button" class="step-action-btn" (click)="moveStepDown()" dojoStopPropagation title="Move down">
      <dojo-icon icon="chevron-down" [size]="12" />
    </button>
    <button
      type="button"
      class="step-action-btn step-action-btn--danger"
      (click)="removeStep()"
      dojoStopPropagation
      title="Remove step"
    >
      <dojo-icon icon="trash" [size]="12" />
    </button>
  </div>

  @if (titleEditing()) {
    <span
      #titleElement
      class="step-title-input step-title-input--contenteditable"
      contenteditable="true"
      (input)="onTitleInput($event)"
      (blur)="stopTitleEdit()"
      (keydown.enter)="$event.preventDefault()"
      (click)="$event.stopPropagation()"
      dojoStopPropagation
    ></span>
  } @else if (titleHasMarkdown()) {
    <span
      class="step-title-input step-title-input--rendered"
      (click)="startTitleEdit(); $event.stopPropagation()"
      contenteditable="false"
      dojoStopPropagation
    >
      <markdown [data]="stepTitle()!" [inline]="true" katex [katexOptions]="katexOptions" />
    </span>
  } @else {
    <span
      #titleElement
      class="step-title-input step-title-input--contenteditable"
      [attr.contenteditable]="true"
      (input)="onTitleInput($event)"
      (keydown.enter)="$event.preventDefault()"
      (click)="$event.stopPropagation()"
      dojoStopPropagation
    ></span>
  }
} @else {
  @if (stepTitle()) {
    <div class="recipe-step-title">
      <markdown [data]="stepTitle()!" [inline]="true" katex [katexOptions]="katexOptions" />
    </div>
  }
}

<div tiptapNodeViewContent></div>
